import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const ReviewsRoot = styled('div', {
  width: '100%',
  background: 'transparent',
  display: 'block',
  position: 'relative',
  zIndex:2,
})

export const WaveSection = styled('div', {
  width: '100%',
  position: 'absolute',
  top: '-159px',
  zIndex: 2,

  '@bp2': {
    top: '-38px',
  }
})

export const SectionWrapper = styled('div',{
  background: '$accent-white',
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  paddingBottom: '60px',
  paddingTop: '40px',

  '@bp2': {
    paddingTop: '48px',
  },

  variants: {
    icon: {
      true: {
        paddingTop: '0px',
        '@bp2': {
          paddingTop: '136px',
        }
      },
    }
  }
})

export const BorderSpace = styled('div', {
  height: '100px',
  background: '$tertiary-200',
  marginTop: '-2px',
})

export const MailWrapper = styled('div', {
  position: 'absolute',
  width: '240px',
  top: '-100px',
  left: 0,
  right: 0,
  margin: 'auto',
  zIndex: 2,
})

export const WaveWrapper = styled('div', {
  position: 'relative',
  display: 'block',
  width: '1920px',
  height: 'auto',
  '@bp2': {
    display: 'block',
  },
})

export const ReviewSection = styled('div', {
  display: 'none',

  '@bp2': {
    display: 'flex',
    gap: '$3',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
})

export const ReviewCard = styled('div', {
  width: '320px',
  background: '$accent-white',
  borderRadius: '28px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '24px 24px 12px 24px',
  margin: 'auto',
  marginBottom: '16px',
  alignItems: 'center',

  '& span:last-child': {
    marginTop: '20px',
  },

  '@bp2': {
    width: '320px',
    padding: '32px 48px 24px 48px',
    margin: 'unset'
  },

  '@bp3': {
    width:'380px'
  },

})

export const DogImageWrapper = styled('div', {
  position: 'relative',
  width: '180px',
  margin: 'auto',
  '@bp2': {
    width: '220px',
  },
})

export const RatingWrapper = styled('div', {
  position: 'relative',
  display: 'flex',
  width: '130px',
  justifyContent: 'center',
  gap: '4px',
  margin: 'auto',
  marginTop: '28px',
  marginBottom: '12px',
  '@bp2': {
    marginTop: '18px',
    marginBottom: '24px',
  },
})

export const SectionTitle = styled(Text, {
  width: '100%',
  margin: 'auto',
  paddingBottom: '42px',
  position: 'relative',
  zIndex: 3,
  '@bp2': {
    margin: 'auto',
  },
  variants: {
    size: {
      h1: {
        fontSize: '$h2',
        '@bp2': {fontSize: '$h1'}
      }
    }
  }
})

export const MobileWrapper = styled('div', {
  display: 'block',
  '@bp2': { display: 'none' },

  '& .slick-dots li button:before': {
    fontSize: '12px',
  },

  '& .slick-dots li.slick-active button:before': {
    color: '$primary-500',
    opacity: 1,
  },
})

export const CarouselItem = styled('div', {
  margin: 'auto',
})

export const Spacer = styled('div', {
  height: '40px',
})

export const Comment = styled('p', {
  textAlign: 'center',
  color: '$accent-black',
  fontSize: '$body',

  '@bp2': {
    fontSize: '$bodyLarge',
    minHeight: '140px',
  },

  variants: {
    author: {
      default: {},

      seth: {
        maxWidth: '285px',
        '@bp2': {
          maxWidth: '293px',
        }
      },
    },
  },

  defaultVariants: {
    'author': 'default'
  }

})

